var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOrderlyIconBalance = function SvgOrderlyIconBalance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E8A93",
    fillRule: "evenodd",
    d: "M15.682 10.24a8.004 8.004 0 0 1-15.364 0h4.965a3.513 3.513 0 0 0 2.716 1.28c1.093 0 2.07-.498 2.715-1.28h4.968Zm.158-.64h-4.705c.245-.48.383-1.024.383-1.6 0-.576-.138-1.12-.383-1.6h4.705a8.033 8.033 0 0 1 0 3.2Zm-10.978 0A3.505 3.505 0 0 1 4.48 8c0-.576.138-1.12.383-1.6H.16a8.037 8.037 0 0 0 0 3.2h4.702ZM1.6 3.2A7.972 7.972 0 0 0 .318 5.76h4.965A3.513 3.513 0 0 1 8 4.48c1.092 0 2.07.498 2.715 1.28h4.968A7.972 7.972 0 0 0 14.4 3.2H1.6Zm12.267-.64H2.134A7.978 7.978 0 0 1 8 0c2.317 0 4.405.985 5.866 2.56Z",
    clipRule: "evenodd"
  })));
};
export default SvgOrderlyIconBalance;